import http, { endpoints } from '../http'
import { IArticleDto } from './dtos'
import { mapArticleFromDto } from './helpers'
import { IArticle } from './models'

const datahubClient = http.createClient(endpoints.datahub)

export default class SupportApi {
	static async getArticles(locale: string) {
		let language = 'EN'

		if (locale.includes('da') || locale.includes('dk')) language = 'DA'
		if (locale.includes('sv') || locale.includes('se')) language = 'SV'
		if (locale.includes('no')) language = 'NO'
		if (locale.includes('vi')) language = 'VI'

		const response = await datahubClient.get<IArticleDto[]>(`/help-articles/language/${language}`)
		return response?.data?.map(mapArticleFromDto) || []
	}

	static async getArticleContentById(id: IArticle['id'], locale: string) {
		const allArticles = await this.getArticles(locale)
		return allArticles.find(article => article.id === id)?.content
	}
}
